import React from "react";
import CreationRequest from "../../components/CreateRequest/CreationRequest";
import "./style.scss";

const CreateRequestPage = () => {
  return (
    <div className="create_request_page">
      <CreationRequest />
    </div>
  );
};

export default CreateRequestPage;
